import { render, staticRenderFns } from "./NewGalleryImage.vue?vue&type=template&id=609b0f26&"
import script from "./NewGalleryImage.vue?vue&type=script&lang=js&"
export * from "./NewGalleryImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports